<template>
    <div v-if="isCheck" class="swip-g">
        <vue-pull-refresh class="refresh" :on-refresh="onRefresh" :config="refreshConfig">
            <div class="headerContainer">
                <a class="urlLogo" @click="goToStartPage">
                <img v-if="companyConfig.companyLogo" class="logoContainer" :src="companyConfig.companyLogo" />
                <img v-else class="logoContainer" src="../../public/img/Skyservice_logo_2022_512.png" />
            </a>
                <div class="nameContainer">{{ companyConfig.companyName }}</div>

            </div>
        </vue-pull-refresh>

        <Swiper v-if="orders && orders.length" @startLoader="$emit('startLoader')" :orders="orders"
            :paymentType="paymentType" :uuidGets="uuidGets" :isActiveReviews="isActiveReviews" :onRefresh="onRefresh"></Swiper>
    </div>
    <div v-else>
        <vue-pull-refresh class="refresh" :on-refresh="onRefresh" :config="refreshConfig">
            <div class="headerContainer">
                <a class="urlLogo" @click="goToStartPage">
                <img  v-if="companyConfig.companyLogo" class="logoContainer" :src="companyConfig.companyLogo" />
                <img v-else class="logoContainer" src="../../public/img/Skyservice_logo_2022_512.png" />
            </a>
                <div class="nameContainer">{{ companyConfig.companyName }}</div>
            </div>

            <div v-if="orders && orders.length" class="contentContainer">
                <h2 class="headerText">Виберіть необхідне замовлення</h2>
                <div class="orders">
                    <template v-for="(order) in orders">
                        <CurrentOrder :prepaymentData="prepaymentsDatas[order.id]" :order="order"
                            @startLoader="$emit('startLoader')" :paymentType="paymentType" :uuidGets="uuidGets"
                            :key="order.id" :isActiveReviews="isActiveReviews" :onRefresh="onRefresh" />
                    </template>
                    <div class="footerContainerSize"></div>
                    <!-- Вхід в оферту закладу — тут, а не біля кнопки: рядок
                         «Продовжуючи…» поруч із кнопкою веде в договір платника
                         платіжки, це інший документ. Умову myTheme лишено лише
                         на «Powered by»: тема ховає нашу атрибуцію, а не
                         юридичне посилання. -->
                    <div class="footerContainer footerCheck">
                        <!-- Знаки тут, а не в кожній картці: у цій верстці
                             замовлень на екрані кілька, і пара логотипів під
                             кожним читалася б як сміття. Смуга закріплена
                             внизу, тож вони однаково поруч із кнопками. -->
                        <div class="footerRow">
                            <TermsLinks />
                            <CardBrandsMark compact />
                        </div>
                        <span v-if="'myTheme' !== nameTheme">
                            Powered by <a target="_blank" href="https://skyservice.pro">Skyservice POS</a>
                        </span>
                    </div>
                </div>
            </div>
        </vue-pull-refresh>
    </div>


</template>
<script>

import CurrentOrder from "./scroll/currentOrder.vue" //Варіант де всі разом скролл
import Swiper from "./swiper/Swiper.vue"
import VuePullRefresh from "vue-pull-refresh";
import TermsLinks from "./TermsLinks.vue";
import CardBrandsMark from "./CardBrandsMark.vue";


export default {
    props: ['orders', 'paymentType', 'uuidGets', 'isCheck', 'nameTheme', 'companyConfig', 'onRefresh','goToStartPage','isActiveReviews'],
    data() {
        return {
            refreshConfig: {
                errorLabel: "Не вдалося оновити",
                startLabel: "Потягніть донизу, щоб оновити список замовлень",
                readyLabel: "Відпустіть, щоб оновити",
                loadingLabel: "Завантаження",
                // pullDownHeight: 400
            },
        };
    },
    components: {
        CurrentOrder,
        Swiper,
        VuePullRefresh,
        TermsLinks,
        CardBrandsMark
    },
    computed: {
        prepaymentsDatas() {
            const datas = {};
            this.orders.forEach(order => {
                if (!order.prepaymentData) return
                const prepaymentData = Object.values(order.prepaymentData);
                const sum = prepaymentData.reduce((acum, elem) => acum + +elem.sum, 0);
                if (!order.id) return
                datas[order.id] = sum;
            });
            return datas;

        },
    }
};

</script>

<style scoped>
/* Смуга стала дворядковою (умови + «Powered by»), тож жорсткі 20px із
   глобального .footerContainer тут перебиваємо.

   Притиснута до низу, як у свайп-верстці: у потоці вона лягала одразу під
   список, і на одному короткому замовленні висіла посеред екрана. Місце під
   неї в кінці списку тримає .footerContainerSize. */
.footerCheck {
    height: auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* 4px — як у футері StartPage.vue: між рядками футера скрізь один відступ. */
    gap: 4px;
    padding-bottom: 10px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 999;
}

/* 16px, більше за внутрішні 8px між самими знаками: інакше посилання й два
   знаки читаються як три однакові елементи, а не як підпис плюс група. */
.footerRow {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
}

/* .terms-links тягнеться на всю ширину, щоб центруватись самостійно; у рядку
   зі знаками це відтіснило б їх до правого краю. */
.footerRow ::v-deep .terms-links {
    width: auto;
}

/* Під дворядкову смугу: рядок зі знаками (16px) + gap + «Powered by» + падінг. */
.footerContainerSize {
    height: 52px;
    min-height: 52px;
}

/* TermsLinks за замовчуванням фарбується --text-head — під футер стартової
   сторінки, де сусідній «Powered by» саме цього кольору. Тут фон інший
   (--content), тож рівняємось на сусіда цієї смуги. */
.footerCheck ::v-deep .terms-links__item {
    color: var(--text-content) !important;
}
</style>
